<template>
  <v-dialog v-model="dialog" persistent width="400">
    <v-card>
      <v-card-title class="d-flex">
        Commission Details
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text class="pt-2">
        <div>
          <v-row>
            <v-col cols="6"> Phone </v-col>
            <v-col cols="6" class="font-weight-bold"> {{ item.phone }} </v-col>
            <v-col cols="6"> Provider </v-col>
            <v-col cols="6" class="font-weight-bold">
              {{ provider.name }}
            </v-col>
            <v-col cols="6"> Amount </v-col>
            <v-col cols="6" class="font-weight-bold">
              Rs {{ item.amount }}
            </v-col>
            <v-col cols="6"> Commission </v-col>
            <v-col cols="6" class="font-weight-bold">
              {{
                item.perc == "True"
                  ? `${item.value || 0} %`
                  : `Rs ${item.value || 0}`
              }}</v-col
            >
          </v-row>
        </div>
        <div class="caption red--text mt-5">
          Note: Please verify all information before doing transactions. After
          the transaction, our company will not responsible.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import rechargeService from "../../../assets/services/recharge.service";
export default {
  data() {
    return {
      dialog: false,
      item: {},
      provider: {},
    };
  },
  methods: {
    submit() {
      this.dialog = false;
      this.$emit("continue");
    },
    async init({ phone, amount, provider, type }) {
      const vm = this;
      let { MobileNo } = this.$store.getters.user;
      console.log(MobileNo);
      if (vm.websiteType == "login" && !MobileNo) {
        vm.$alert.show("Login required");
        return;
      }
      vm.provider = provider;
      let params = {
        Service: provider.Service,
        ServiceType: type,
        Amount: amount,
      };
      try {
        vm.$loader.show();
        let { data } = await rechargeService.calculateCharge(params);
        if (data.status == "true") {
          vm.item = data.data;
          vm.item.phone = phone;
          vm.dialog = true;
        } else {
          vm.$alert.show(data.message);
        }
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style>
</style>